import { ScrollTop } from "../../config/ScrollTop";
import { Aboutme } from "../../components/user-components/Aboutme/Aboutme";
import { Contactme } from "../../components/user-components/Contactme/Contactme";
import { ProjectHead } from "../../components/user-components/Header/ProjectHead";
import { SkillsHead } from "../../components/user-components/Header/SkillsHead";
import { Projectme } from "../../components/user-components/Projectme/Projectme";
import { Skillme } from "../../components/user-components/Skillme/Skillme";

export const Mobile = () => {
  return (
    <>
    <ScrollTop />
    <Aboutme/>
    <SkillsHead />
    <Skillme />
    <ProjectHead />
    <Projectme />
    <Contactme />

    </>
  );
};
